/**
 * Generic client-side table search helper. Search is purely in-memory over the
 * rows already loaded in a table — it never calls the BFF/database. Matching is
 * a case-insensitive substring over the *visible* cell content, so a query
 * matches exactly what the user sees on screen.
 */
/**
 * True when `term` (trimmed, case-insensitive) is a substring of the joined,
 * non-empty parts. An empty / whitespace-only term matches everything.
 */
export function matchesSearchTerm(parts, term) {
    const needle = term.trim().toLowerCase();
    if (!needle)
        return true;
    return parts
        .filter((p) => !!p)
        .join(" ")
        .toLowerCase()
        .includes(needle);
}
